// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_13uKx715GF0dlASUBT08sQ","title":"_1bTAKgbc5G7kooSg5jKdna"};